import { Login } from "./pages/Login";
import { Layout } from "./components/Layout";
import { useAuth } from "./auth/AuthContext";

/**
 * The auth gate. It decides whether anyone gets in at all; once they do, Layout
 * and the router own what they see. The status handling is unchanged from the
 * pre-router shell — only the authenticated branch now hands off to Layout,
 * whose Outlet the routes render into.
 */
export default function App() {
  const { status, user } = useAuth();

  if (status === "loading") {
    return <main className="grid min-h-dvh place-items-center text-sm text-gray-500">Loading…</main>;
  }

  if (status === "unreachable") {
    // Not a sign-out: the session may be fine and the server merely mid-deploy (§3.3).
    return (
      <Centered title="Can't reach the server" body="Retrying automatically. Your session is still valid." />
    );
  }

  if (status === "denied") {
    // request() is already navigating to the Hub's modal, which names the app.
    return (
      <Centered
        title="You don't have access to CE Hub"
        body="Taking you back to the Hub to ask your administrator."
      />
    );
  }

  if (!user) return <Login />;

  return <Layout />;
}

function Centered({ title, body }: { title: string; body: string }) {
  return (
    <main className="grid min-h-dvh place-items-center p-4 text-center">
      <div>
        <p className="text-md font-medium text-gray-900">{title}</p>
        <p className="mt-1 text-sm text-[var(--text-2)]">{body}</p>
      </div>
    </main>
  );
}
